<template>
  <div style="width:100% margin-top:10px">
    <b-row class="m-0 text-center instance">
      <b-col class="p-0">
        <div class="img-cover">
        </div>
        <img class="d-block img-fluid w-100" :src="itemData.sourceUrl" alt="" />

        <div class="innerbox">
          <div class="instance-txt" @click="goToDeatil(itemData)">
            <i class="vedio_icon" v-if="itemData.type=='视频'"></i>
            {{itemData.postTitle}}
            <!-- 2 New Imported Cases Reported In Shanghai -->
          </div>
          <template v-if="itemData.category">
            <span class="text-uppercase metro-btn" v-for="(itemCate,indexCate) in itemData.category.split(',')" :key="indexCate" @click="goToNews(itemCate)"> {{itemCate}}</span>
          </template>
        </div>
        <div class="cover"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "DetialList",
  // props: {
  //   instance: {
  //     type: Array,
  //     default() {
  //       return [];
  //     }
  //   }
  // },
  props: ["itemData"],
  data() {
    return {};
  },
  methods: {
    goToNews(item) {
      this.$router
        .push({
          path: "/News",
          query: {
            cT: item,
          },
        })
        .catch(err => {
          err;
        });
    },
    goToDeatil(item) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: item.postId,
        },
      });
    },
  },
  mounted() {
    // console.log(this.instance)
  },
};
</script>

<style lang="less" scoped>
// instance
.instance {
  width: 100%;
  font-family: FranklinGothic-Demi;
  color: #ffffffff;
}
.innerbox {
  width: calc(100% - 0.4rem);
  margin: 0 0.2rem;
  font-size: 0.6rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .instance-txt {
    line-height: 44px;
  }
  .vedio_icon {
    display: inline-block;
    height: 0.6rem;
    width: 0.6rem;
    background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    position: relative;
    top: 0.1rem;
  }
  .metro-btn {
    position: relative;
    // top: 0.5rem;
    border: 1.3px solid #ffffff;
    cursor: pointer;
    font-size: 9px;
    letter-spacing: 4px;
    padding: 4px 3px 2px 7px;
    font-family: Calibri Bold;
    // font-family: Open Sans;
  }
  .metro-btn:hover {
    background: #666666;
    border: none;
    border-radius: 5px;
  }
}
@media screen and (max-width: 768px) {
  .innerbox {
    width: calc(100% - 0.4rem);
    margin: 0 0.2rem;
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .instance-txt {
      line-height: 24px;
    }
    .vedio_icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      position: relative;
      top: 0.1rem;
    }
    .metro-btn {
      position: relative;
      border: 1.3px solid #ffffff;
      padding: 4px 3px 2px 7px;
      cursor: pointer;
      font-family: Calibri Bold;
      font-size: 9px;
    }
    .metro-btn:hover {
      background: #666666;
      border: none;
      border-radius: 5px;
    }
  }
}
</style>